import { Contacts, type ContactPayload } from '@capacitor-community/contacts'

export interface ImportableContact {
  firstName: string
  lastName: string | null
  email: string | null
  phone: string | null
  company: string | null
  jobTitle: string | null
  birthday: string | null
  avatarUrl: string | null
}

export async function requestContactsPermission(): Promise<boolean> {
  const result = await Contacts.requestPermissions()
  return result.contacts === 'granted'
}

export async function fetchDeviceContacts(): Promise<ImportableContact[]> {
  const result = await Contacts.getContacts({
    projection: {
      name: true,
      phones: true,
      emails: true,
      organization: true,
      birthday: true,
      image: true,
    },
  })

  return result.contacts.filter((c) => c.name?.display || c.name?.given).map(mapContactPayload)
}

function mapContactPayload(contact: ContactPayload): ImportableContact {
  const primaryEmail = contact.emails?.[0]?.address ?? null
  const primaryPhone = contact.phones?.[0]?.number ?? null

  return {
    firstName: contact.name?.given || contact.name?.display || '',
    lastName: contact.name?.family ?? null,
    email: primaryEmail,
    phone: primaryPhone,
    company: contact.organization?.company ?? null,
    jobTitle: contact.organization?.jobTitle ?? null,
    birthday: contact.birthday
      ? `${contact.birthday.year ?? '1900'}-${String(contact.birthday.month ?? 1).padStart(2, '0')}-${String(contact.birthday.day ?? 1).padStart(2, '0')}`
      : null,
    avatarUrl: contact.image?.base64String
      ? `data:image/jpeg;base64,${contact.image.base64String}`
      : null,
  }
}
